var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypographyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58036 5.625C6.50044 5.625 5.625 6.50044 5.625 7.58036V7.98214C5.625 8.39636 5.96078 8.73214 6.375 8.73214C6.78922 8.73214 7.125 8.39636 7.125 7.98214V7.58036C7.125 7.32889 7.32889 7.125 7.58036 7.125H11.25V16.875H9.79016C9.37597 16.875 9.04016 17.2108 9.04016 17.625C9.04016 18.0392 9.37597 18.375 9.79016 18.375H11.9987H12H14.2098C14.624 18.375 14.9598 18.0392 14.9598 17.625C14.9598 17.2108 14.624 16.875 14.2098 16.875H12.75V7.125H16.4196C16.6711 7.125 16.875 7.32889 16.875 7.58036V7.98214C16.875 8.39636 17.2108 8.73214 17.625 8.73214C18.0392 8.73214 18.375 8.39636 18.375 7.98214V7.58036C18.375 6.50044 17.4996 5.625 16.4196 5.625H12H7.58036Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 7.5C0.75 3.77209 3.77209 0.75 7.5 0.75H16.5C20.2279 0.75 23.25 3.77209 23.25 7.5V16.5C23.25 20.2279 20.2279 23.25 16.5 23.25H7.5C3.77209 23.25 0.75 20.2279 0.75 16.5V7.5ZM7.5 2.25C4.6005 2.25 2.25 4.6005 2.25 7.5V16.5C2.25 19.3995 4.6005 21.75 7.5 21.75H16.5C19.3995 21.75 21.75 19.3995 21.75 16.5V7.5C21.75 4.6005 19.3995 2.25 16.5 2.25H7.5Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypographyIcon);
export default __webpack_public_path__ + "static/media/typography_icon.7e31641acc28069d905f695077791eba.svg";
export { ForwardRef as ReactComponent };